export const uiPlaceholder = {
    name: 'UI Placeholder',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        height: {
            name: 'Height',
            type: 'Integer',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ range: { min: 1, max: 1000 } }]
        }
    }
};
//# sourceMappingURL=uiPlaceholder.js.map